/**
 * Prop opcional que só existe quando há valor.
 *
 * O projeto compila com `exactOptionalPropertyTypes`: `erro?: string` aceita a
 * prop ausente, mas recusa `erro={undefined}`. A diferença é real — "não há
 * erro" e "há um erro que ninguém sabe qual" não são a mesma coisa —, então a
 * prop some em vez de vir vazia.
 *
 * ```tsx
 * <CampoTexto rotulo="Login" {...seHouver('erro', erros['login'])} />
 * ```
 */
export function seHouver<C extends string, V>(
  chave: C,
  valor: V | null | undefined,
): { [K in C]?: V } {
  return valor === null || valor === undefined ? {} : ({ [chave]: valor } as { [K in C]?: V });
}
